import React from 'react';

import { Text } from '@/components/TextComponent';
import { AppColors } from '@/components/lib/theme';

import { useEventMatchup } from '../hooks/use-event-matchup';

type EventMatchupTextProps = {
    eventId: string;
    color: AppColors;
};

export const EventMatchupText = ({ eventId, color }: EventMatchupTextProps) => {
    const matchup = useEventMatchup(eventId);

    if (!matchup) {
        return null;
    }

    return (
        <Text variant="bodySmall" color={color}>
            {matchup}
        </Text>
    );
};
